import React from 'react'
import PageStructure from '../components/shared/PageStructure';
import ErrorComp from '../components/ErrorComp';
const ErrorPage = () => {
    return (
        <PageStructure text={'Error'} page={ErrorComp} />
      )
}

export default ErrorPage